import React from 'react'
import url from 'front-end-core/core/url'
import { MW_LIST_DEALS, SEARCH } from 'constants/controllers'
import cx from 'classnames'
import Link from '@material-ui/core/Link'
import ContainedButton from 'components/search/ContainedButton'

const getUrl = (aol, _flavour, searchType, searchTerm, isLogged) => {
  const flavour = searchType === 'qa' && _flavour
  if (searchType !== 'dealwatch') { // standard url form for search buttons
    return url(SEARCH, { aol, flavour, searchType }, { q: searchTerm })
  } // sets the url for dealwatch only if the user is logged in
  return isLogged ? url(MW_LIST_DEALS, { aol, flavour, path: 'all' }, { q: searchTerm }) : null
}

const SearchTypeButton = ({
  searchTerm,
  selected,
  searchType,
  title,
  iconName,
  activeClass,
  isProxy = false,
  setSignUpModalIsOpen,
  isLogged,
  aol,
  flavour
}) => {
  const linkStyle = selected ? { textDecoration: 'none' } : {}
  const activeCx = selected ? activeClass : ''
  const buttonCxNames = cx('ttc b f5', { 'bg-white ba b--cadet-blue': !selected }, activeCx)
  const url = selected || isProxy ? null : getUrl(aol, flavour, searchType, searchTerm, isLogged)
  const handleOnClick = (e) => {
    selected
      ? e.preventDefault()
      : !isLogged && searchType === 'dealwatch' && setSignUpModalIsOpen(true)
  }

  return (
    <Link href={url} style={linkStyle} onClick={handleOnClick}>
      <ContainedButton {...{ buttonCxNames, selected, title, iconName, isProxy }} />
    </Link>
  )
}

export default SearchTypeButton
